"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brandProfileOptionsById = void 0;
exports.getBrandProfileOptionByBrandId = getBrandProfileOptionByBrandId;
var defaultOption = {
    Name: 'Default',
    PasswordRegexPattern: '^[\\S]+.*[\\S]+$',
    PasswordMinLength: 6,
    PasswordRegexErrorMessage: 'Invalid password. Please ensure it is at least 6 characters long.',
};
exports.brandProfileOptionsById = {
    88: {
        Name: 'CDFpay',
        PasswordRegexPattern: '^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])[\\S]+.*[\\S]+$',
        PasswordMinLength: 8,
        PasswordRegexErrorMessage: 'Invalid password. Please ensure it is at least 8 characters long, includes both uppercase and lowercase letters, and contains at least one number.',
    },
};
function getBrandProfileOptionByBrandId(brandId) {
    return exports.brandProfileOptionsById[brandId] || defaultOption;
}
//# sourceMappingURL=BrandProfileOption.js.map